import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { cls, getScrollContainerAttribute, getValidScrollContainer } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import BackArrow from './back-icon';

/**
 * 导航栏组件，支持吸顶和沉浸式，支持在指定滚动位置展示，支持根据滚动位置实时更新style。
 * @type 导航
 * @name 导航栏
 */
var NavBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      onClickLeft = props.onClickLeft,
      _props$leftContent = props.leftContent,
      leftContent = _props$leftContent === void 0 ? /*#__PURE__*/React.createElement(BackArrow, null) : _props$leftContent,
      onClickRight = props.onClickRight,
      rightContent = props.rightContent,
      onShowChange = props.onShowChange,
      style = props.style,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      wrapClass = props.wrapClass,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? true : _props$placeholder,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? true : _props$fixed,
      _props$hasBottomLine = props.hasBottomLine,
      hasBottomLine = _props$hasBottomLine === void 0 ? true : _props$hasBottomLine,
      _props$statusBarHeigh = props.statusBarHeight,
      statusBarHeight = _props$statusBarHeigh === void 0 ? 0 : _props$statusBarHeigh,
      getScrollContainer = props.getScrollContainer,
      _props$showOffset = props.showOffset,
      showOffset = _props$showOffset === void 0 ? 0 : _props$showOffset,
      getComputedStyleByScroll = props.getComputedStyleByScroll;
  var navBarRef = useRef(null);

  var _useState = useState(showOffset > 0),
      scrollToggleHide = _useState[0],
      setScrollToggleHide = _useState[1];

  var relBackground = scrollToggleHide ? 'transparent' : '';

  var _useState2 = useState({}),
      customStyle = _useState2[0],
      setCustomStyle = _useState2[1];

  var onElementScroll = function onElementScroll(curOffset) {
    setScrollToggleHide(curOffset <= showOffset);

    if (getComputedStyleByScroll) {
      var cstyle = getComputedStyleByScroll(curOffset);
      setCustomStyle(cstyle);
    }
  };

  useImperativeHandle(ref, function () {
    return {
      navBar: navBarRef.current,
      dom: navBarRef.current
    };
  });
  useEffect(function () {
    onShowChange == null ? void 0 : onShowChange(!scrollToggleHide);
  }, [scrollToggleHide]);

  var handleEleScroll = function handleEleScroll() {
    var top = getScrollContainerAttribute('scrollTop', getScrollContainer) || 0;
    onElementScroll(top);
  };

  useEffect(function () {
    var needBind = showOffset || getComputedStyleByScroll;
    var container = getValidScrollContainer(getScrollContainer);

    if (needBind && container) {
      container.addEventListener('scroll', handleEleScroll, false);
    }

    return function () {
      if (needBind && container) {
        container.removeEventListener('scroll', handleEleScroll, false);
      }
    };
  }, [showOffset, getComputedStyleByScroll, getScrollContainer]);

  function handleClickLeft(e) {
    if (onClickLeft) {
      onClickLeft(e);
    }
  }

  function handleClickRight(e) {
    if (onClickRight) {
      onClickRight(e);
    }
  } // 最外层div是为了fixed时占位
  // 第二层div是为了沉浸式paddingTop
  // 第三层是为了保证内容高度始终是44px
  // 背景色放到wrapper层是为了兼容iOS下拉回弹的背景色
  // fixed时用height+padding撑开nav-bar最外层高度；不fixed时内部wrapper元素撑开最外层高度


  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var _cls, _cls2;

    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("div", {
      ref: navBarRef,
      className: cls(wrapClass, prefixCls + "-nav-bar", (_cls = {}, _cls[prefixCls + "-nav-bar-fixed"] = fixed, _cls[prefixCls + "-nav-bar-float"] = !placeholder, _cls[prefixCls + "-nav-bar-hide"] = scrollToggleHide, _cls)),
      style: _extends({
        paddingTop: fixed && statusBarHeight ? statusBarHeight + "px" : ''
      }, style || {}, relBackground ? {
        background: relBackground
      } : {})
    }, /*#__PURE__*/React.createElement("div", {
      className: cls(className, prefixCls + "-nav-bar-wrapper", (_cls2 = {}, _cls2[prefixCls + "-nav-bar-wrapper-fixed"] = fixed, _cls2[prefixCls + "-nav-bar-wrapper-border"] = hasBottomLine, _cls2)),
      style: _extends({
        paddingTop: statusBarHeight ? statusBarHeight + "px" : ''
      }, customStyle)
    }, /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-nav-bar-inner all-border-box"
    }, leftContent ? /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-nav-bar-left",
      onClick: handleClickLeft
    }, leftContent) : null, children || /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-nav-bar-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-nav-bar-title-text"
    }, title)), rightContent ? /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-nav-bar-right",
      onClick: handleClickRight
    }, rightContent) : null)));
  });
});
export default NavBar;